import { FC, ReactNode } from "react";
import {
  Box,
  FormControl,
  InputAdornment,
  InputLabel,
} from "@material-ui/core";
import { Help as HelpIcon } from "@material-ui/icons";

import { FormHelperTextExtra } from "components/FormHelperText";
import { InputExtra, InputExtraProps } from "components/Input";

import { Tooltip } from "../../components";

interface NumberFieldProps {
  adornmentElement?: ReactNode;
  adornmentPosition?: "start" | "end";
  helperText: string;
  label: string;
  tooltipText?: ReactNode;
}

const NumberField: FC<NumberFieldProps & InputExtraProps> = ({
  adornmentElement,
  adornmentPosition = "start",
  error,
  helperText,
  label,
  tooltipText,
  warning,
  ...restProps
}) => (
  <>
    <FormControl fullWidth>
      <Box display="flex" alignItems="flex-end">
        <Box width="100%">
          {label && (
            <InputLabel htmlFor="number-field" shrink>
              <Box display="flex" alignItems="center">
                {label}
                {tooltipText && (
                  <Tooltip title={tooltipText}>
                    <Box ml={1}>
                      <HelpIcon fontSize="small" />
                    </Box>
                  </Tooltip>
                )}
              </Box>
            </InputLabel>
          )}
          <InputExtra
            id="number-field"
            type="number"
            fullWidth
            startAdornment={
              adornmentElement && adornmentPosition === "start" ? (
                <InputAdornment position="start">
                  {adornmentElement}
                </InputAdornment>
              ) : undefined
            }
            endAdornment={
              adornmentElement && adornmentPosition === "end" ? (
                <InputAdornment position="end">
                  {adornmentElement}
                </InputAdornment>
              ) : undefined
            }
            inputProps={{ style: { width: "100%" }, step: "any" }}
            warning={warning}
            error={error}
            {...restProps}
          />
        </Box>
      </Box>
    </FormControl>
    {helperText && (
      <FormHelperTextExtra warning={warning} error={error}>
        {helperText}
      </FormHelperTextExtra>
    )}
  </>
);

export default NumberField;
